module.exports = __webpack_public_path__ + "static/img/icon-xinxihedui.0006cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/icon-xinxihedui.png
// module id = 1556
// module chunks = 0